module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAOCAYAAAA1+Nx+AAAAcklEQVQ4je2TSwrAIAxEJ8XzVO9/ingiu3ERzKQ/lG46IMYQ5jmC0vLesFDbSvMPAFoRnrX6ZWfGvSs5pFagZH6dqH8iDyg5howJbwA9wEJY/6E4IIKwBDYxSS7/P7hSAiC9tk8lZPaVWIJp5gww1RwADjrSJ6Qdl+HnAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/new_ico.png
// module id = ajgZ
// module chunks = 1